import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=6a4b0739&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=ts&"
export * from "./Paginate.vue?vue&type=script&lang=ts&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=6a4b0739&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4b0739",
  null
  
)

export default component.exports